//============================================================================
// Name        : ReprintLabels.tsx
// Purpose     : Implement Warehouse recive print labels
// Created     : 2019-07-01
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

/** @jsx jsx */ jsx;
import { css, jsx } from "@emotion/core";
import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import Select from "react-select";
import Switch from "react-switch";
import * as GlobalSettings from "../../globalSettings";
import { IFetchPrintersAction, ISetPrintStateAction, ISetSavePrinterAction, ISetSelectedPrinterAction } from "./actions/printerActions";
import ReprintItem from "./ReprintItem";
import { IPrinterModel, IPrinterOption, IPrintState, IReprintLabelsProps, PrinterActions, ReceiveActions, TagType } from "./types";

const printingWrapper = css`
    font-family: Verdana;
    display: flex;
    justify-content: space-around;
    max-height: 50vh;
    overflow-y: scroll;
`;

const sectionTitle = css`
    text-align: center;
    font-family: Verdana;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
`;

declare var apiKey: string;
declare var apiUrl: string;

class ReprintLabels extends React.Component<IReprintLabelsProps> {
    getClassName = () => this.props.show ? "modal show" : "modal fade";
    getItem = () => this.props.receptionItems.find(it => it.id == this.props.itemId);
    onSavePrinterChange = (value: boolean) => this.props.setSavePrinter(value);
    onPrinterChange = (option: IPrinterOption) => {
        if (this.props.savePrinter) {
            this.props.saveDefaultPrinter(option);
        }
        else {
            this.props.setSelectedPrinter(option);
        }
    }

    onClose = () => this.props.hideReprintDialog();
    onReprintAll = async () => {
        // Send labels to the server to start printing
        const printData = {
            api_key:   apiKey,
            printerId: this.props.selectedPrinter.value,
            labels:    this.getItem().labels
        };
        await axios.post(apiUrl + "/print-labels", printData);
    }

    render() {
        const palletLabels = this.getItem().labels.filter(l => l.tagType == TagType.Pallet);
        const caseLabels   = this.getItem().labels.filter(l => l.tagType == TagType.Case);
        return (
            <div className={this.getClassName()} tabIndex={-1} role="dialog">
                <div className="modal-dialog" css={{ width: "85%" }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <button onClick={this.onClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div css={{ display: "flex", justifyContent: "space-between" }}>
                                <h1 className="modal-title">
                                    <img src="/images/printer.png" alt="Printer" css={{ height: "90px" }}/>
                                    Reprint RFID Tags
                                </h1>
                                <button onClick={this.onReprintAll} className="man-btn man-green-btn" css={{ height: "50px", marginTop: "26px" }}>Re-Print All</button>
                                <div>
                                    <div css={{ fontSize: "16px", fontWeight: "bold" }}>RFID Printer</div>
                                    <div css={{ width: "100%" }}><Select options={this.props.printers} onChange={this.onPrinterChange} value={this.props.selectedPrinter} styles={GlobalSettings.selectCustomStyle} /></div>
                                    <div css={{ marginTop: "10px", display: "flex", alignItems: "center" }}>
                                        <Switch onChange={this.onSavePrinterChange} checked={this.props.savePrinter} />
                                        <span css={{ fontSize: "16px", marginLeft: "10px" }}>Save printer as default</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-body">
                            <div css={printingWrapper} className="mf-printing-wrapper">
                            <div className="mf-reprint-dlg-pallets" css={{ width: "50%", marginRight: "40px" }}>
                                <div className="section-title" css={sectionTitle}>Pallet Labels</div>
                                <div>
                                    {palletLabels.map((label, key) => <ReprintItem key={key} label={label} />)}
                                </div>
                            </div>

                            <div className="mf-reprint-dlg-individuals" css={{ width: "50%", marginRight: "10px" }}>
                                <div className="section-title" css={sectionTitle}>Individual Labels</div>
                                <div>
                                    {caseLabels.map((label, key) => <ReprintItem key={key} label={label} />)}
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    show:                state.receiveOrders.showReprintDialog,
    printers:            state.printers.items,
    printerModels:       state.receiveOrders.printers,
    reception:           state.receiveOrders.reception,
    receptionItems:      state.receiveOrders.reception.external_receive_items,

    savePrinter:         state.printers.savePrinter,
    defaultPrinter:      state.printers.defaultPrinter,
    selectedPrinter:     state.printers.selectedPrinter,

    // Printing status props
    palletCount:         state.printers.palletCount,
    caseCount:           state.printers.caseCount,
    detectedPalletCount: state.printers.detectedPalletCount,
    detectedCaseCount:   state.printers.detectedCaseCount,
    printing:            state.printers.printing
});
const mapDispatchToProps = dispatch => ({
    fetchPrinters: (printers: IPrinterModel[]) => dispatch({
        type: PrinterActions.FetchPrinters,
        printers
    } as IFetchPrintersAction),
    setSavePrinter: (value: boolean) => dispatch({
        type: PrinterActions.SetSavePrinter,
        value
    } as ISetSavePrinterAction),
    saveDefaultPrinter: (printer: IPrinterOption) => dispatch({
        type: PrinterActions.SaveDefaultPrinter,
        printer
    }),
    setSelectedPrinter: (printer: IPrinterOption) => dispatch({
        type: PrinterActions.SetSelectedPrinter,
        printer
    } as ISetSelectedPrinterAction),
    setPrintState: (props: Partial<IPrintState>) => dispatch({
        type: PrinterActions.SetPrintState,
        payload: { props }
    } as ISetPrintStateAction),
    hideReprintDialog: () => dispatch({
        type: ReceiveActions.HideReprintDialog
    })
});
export default connect(mapStateToProps, mapDispatchToProps)(ReprintLabels);
